module.exports = __webpack_public_path__ + "static/media/img_cards.2986e2d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@3x/img_cards.png
// module id = 341
// module chunks = 0